"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Select_1 = __importDefault(require("@material-ui/core/Select"));
const styles_1 = require("@material-ui/core/styles");
const helpers_1 = require("@material-ui/core/utils/helpers");
const FormControl_1 = __importDefault(require("../FormControl"));
const InputLabel_1 = __importDefault(require("../InputLabel"));
const Input_1 = __importDefault(require("../Input"));
const OutlinedInput_1 = __importDefault(require("../OutlinedInput"));
const MenuItem_1 = __importDefault(require("../MenuItem"));
const styles_2 = __importDefault(require("./styles"));
const renderOptions = (options, placeholder, isNative) => {
    if (!options.length) {
        return null;
    }
    const OptionComponent = isNative ? 'option' : MenuItem_1.default;
    const resultOptions = options.map(({ key, value, text }) => (react_1.default.createElement(OptionComponent, { key: key || value, value: value }, text)));
    if (placeholder) {
        resultOptions.unshift(react_1.default.createElement(OptionComponent, { disabled: true, key: 'placeholder', value: '' }, placeholder));
    }
    return resultOptions;
};
exports.Select = ({ classes, className, style, width, id, label, native, options, placeholder, variant, disabled, onChange, value }) => {
    const hasLabel = !!label;
    const fullWidth = width === 'full';
    const outlinedInput = variant === 'outlined' ? (react_1.default.createElement(OutlinedInput_1.default, { classes: {
            input: hasLabel ? classes.inputWithLabel : classes.input
        }, fullWidth: fullWidth, labelWidth: 0 })) : (react_1.default.createElement(Input_1.default, { classes: {
            input: hasLabel ? classes.inputWithLabel : classes.input
        }, disableUnderline: true, fullWidth: fullWidth }));
    const select = (react_1.default.createElement(Select_1.default, { className: className, style: style, classes: {
            root: classnames_1.default(classes.root, classes[`root${helpers_1.capitalize(width)}`]),
            icon: classes.icon,
            select: classes.select
        }, displayEmpty: true, id: id, input: outlinedInput, native: native, variant: variant, disabled: disabled, value: value, MenuProps: {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left'
            },
            getContentAnchorEl: undefined // needed to restore default behaviour
        }, onChange: onChange }, renderOptions(options, placeholder, native)));
    return (react_1.default.createElement(FormControl_1.default, { className: classnames_1.default(className, { [classes.rootFull]: fullWidth }) },
        hasLabel && (react_1.default.createElement(InputLabel_1.default, { classes: {
                root: classes.label,
                shrink: classes.labelShrink
            }, htmlFor: id, variant: variant }, label)),
        select));
};
exports.Select.defaultProps = {
    disabled: false,
    native: false,
    onChange: () => { },
    value: '',
    variant: 'outlined',
    width: 'full'
};
exports.Select.displayName = 'Select';
exports.default = styles_1.withStyles(styles_2.default)(exports.Select);
//# sourceMappingURL=Select.js.map